namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_map_page_contextmenu, {

		maxHeight: '440px',
		flex: {
			direction: 'column',
		},

		Search: {
			width: '100%',
		},

		List: {
			flex: {
				grow: 1,
				shrink: 1,
			},
			minHeight: 0,
			overflow: {
				y: 'auto',
			},
		},
		
		Item_add: {
			flex: {
				grow: 1,
			},
			'[widget_type]': {
				'ai_request': {
					color: $mol_theme.special,
				},
				'opencode_session': {
					color: $mol_theme.special,
				},
			},
		},

	} )

	$mol_style_define( $shm_hitalama_map_page_contextmenu_add, {

		'[selected]': {
			true: {
				background: {
					color: $mol_theme.hover,
				},
			},
		},

	} )
	
}
